<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p v-if="state.mode">관리자 추가</p>
            <p v-else>관리자 수정</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sign_form custom_scroll">
            <ul>
                <li :class="{ imp: state.mode }">
                    <label for="user_id" class="form_li_tit">아이디</label>
                    <input
                        id="user_id"
                        type="text"
                        v-model="form_state.id"
                        @change="state.idExistCheck = false"
                        :class="{ blocked: !state.mode }"
                        :disabled="!state.mode"
                    />
                    <button v-if="state.mode" class="blue_btn" @click="idExist">중복확인</button>
                    <p class="p_info" v-if="!state.idIsPossible && state.mode">영문자, 숫자, _만 입력 가능/ 최소 6자 이상 12자 이하로 입력하세요.</p>
                </li>

                <li :class="{ imp: state.mode }">
                    <label for="" class="form_li_tit">이름</label>
                    <input
                        type="text"
                        placeholder="이름을 입력하세요"
                        v-model="form_state.name"
                        :class="{ blocked: !state.mode }"
                        :disabled="!state.mode"
                    />
                </li>

                <li :class="{ imp: state.mode }">
                    <label for="user_pw" class="form_li_tit">비밀번호</label>
                    <input id="user_pw" type="password" placeholder="비밀번호를 입력하세요" v-model="form_state.pw" />
                    <p class="p_info" v-if="!state.pwIsPossible">비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요.</p>
                </li>

                <li :class="{ imp: state.mode }">
                    <label for="user_pw_chk" class="form_li_tit">비밀번호 확인</label>
                    <input id="user_pw_chk" type="password" placeholder="비밀번호 확인" v-model="form_state.pwConfirm" />
                    <p class="p_warn" v-if="state.pwIsPossible && form_state.pw !== form_state.pwConfirm">
                        *비밀번호가 일치하지 않습니다. 다시 입력해주세요.
                    </p>
                </li>

                <li class="join_way_wrap checkbox_wrap" :class="{ imp: state.mode }">
                    <span class="form_li_tit">담당사업</span>
                    <label
                        v-for="(item, index) in state.roleList"
                        :key="item.roIdx"
                        :for="'join_way' + item.roIdx"
                        :class="item.roIdx === 5 ? 'need_space' : ''"
                    >
                        <input type="checkbox" :id="'join_way' + item.roIdx" name="join_way" :value="item.roIdx" v-model="state.selectedRole" />
                        <em></em>
                        <span>{{ item.roName }}</span>
                    </label>
                </li>
            </ul>

            <hr />
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">취소</button>
                <button v-if="!(form_state.idx && form_state.idx > 0)" class="submit_btn _130 _main_blue" @click="add">추가</button>
                <button v-else class="submit_btn _130 _main_blue" @click="modify">수정</button>
            </div>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts">
    import { onMounted, reactive, watch, CommonUtils, types, apiService, ModalDefault } from "@/BaseComponent";

    export default {
        props: {
            idx: { type: Number, default: 0 },
            userInfo: { type: Object },
            modalRoleList: { type: Array<string>, default: [] },
            allRoleList: { type: Array<any>, default: [] },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                roleList: [] as Array<any>,
                idIsPossible: false,
                pwIsPossible: false,
                pwReCheck: false,
                roleCheck: false,
                idExistCheck: false,
                selectedRole: [] as number[],

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                mode: true as boolean, // true: add, false: modify
            });

            const form_state = reactive({
                idx: 0 as number,
                id: "" as string,
                name: "" as string,
                pw: "" as string,
                pwConfirm: "" as string,
                roleList: [] as number[],
            });

            const convertNamesToIdxs = (names: Array<string>) => {
                if (!names) return [];
                return props.allRoleList.filter((item: any) => names.includes(item.roName)).map((item: any) => item.roIdx);
            };

            onMounted(() => {
                state.idIsPossible = false;
                state.pwIsPossible = false;
                state.pwReCheck = false;
                state.idExistCheck = false;
                state.selectedRole = [];
                state.roleList = props.allRoleList;

                if (props.idx && props.idx > 0) {
                    form_state.idx = props.idx;
                    form_state.id = props.userInfo.id;
                    form_state.name = props.userInfo.name;
                    form_state.pw = "";
                    form_state.pwConfirm = "";

                    const idxs = convertNamesToIdxs(props.modalRoleList);
                    form_state.roleList = [...idxs];
                    state.selectedRole = [...idxs];
                    state.roleCheck = form_state.roleList.length > 0;

                    state.mode = false;
                } else {
                    form_state.idx = 0;
                    form_state.id = "";
                    form_state.name = "";
                    form_state.pw = "";
                    form_state.pwConfirm = "";
                    form_state.roleList = [];
                    state.selectedRole = [];
                    state.roleCheck = false;

                    state.mode = true;
                }
            });

            watch(props, () => {
                state.idIsPossible = false;
                state.pwIsPossible = false;
                state.pwReCheck = false;
                state.idExistCheck = false;
                state.selectedRole = [];
                state.roleList = props.allRoleList;

                if (props.idx && props.idx > 0) {
                    form_state.idx = props.idx;
                    form_state.id = props.userInfo.id ?? "";
                    form_state.name = props.userInfo?.name ?? "";
                    form_state.pw = "";
                    form_state.pwConfirm = "";

                    const idxs = convertNamesToIdxs(props.modalRoleList);
                    form_state.roleList = [...idxs];
                    state.selectedRole = [...idxs];
                    state.roleCheck = form_state.roleList.length > 0;

                    state.mode = false;
                } else {
                    form_state.idx = 0;
                    form_state.id = "";
                    form_state.name = "";
                    form_state.pw = "";
                    form_state.pwConfirm = "";
                    form_state.roleList = [];
                    state.selectedRole = [];
                    state.roleCheck = false;

                    state.mode = true;
                }
            });

            watch(
                () => state.selectedRole,
                (newVal) => {
                    form_state.roleList = [...newVal];
                    state.roleCheck = form_state.roleList.length > 0;
                },
            );

            watch(
                () => form_state.id,
                (newVal) => (state.idIsPossible = CommonUtils.regexForId.test(newVal)),
            );

            watch(
                () => [form_state.pw, form_state.pwConfirm],
                () => {
                    state.pwReCheck = state.pwIsPossible && form_state.pw === form_state.pwConfirm;

                    state.pwIsPossible = CommonUtils.regexForPassword.test(form_state.pw);
                },
            );

            const closeModal = () => emit("close");

            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    emit("callback");
                } else {
                    state.isShowModal = false;
                }
            };

            const idExist = async () => {
                state.idExistCheck = false;
                if (!form_state.id) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "아이디를 입력해주세요.";
                    state.isShowModal = true;
                    return;
                } else if (!state.idIsPossible) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "아이디가 올바르지 않습니다.";
                    state.isShowModal = true;
                    return;
                } else {
                    const res = await apiService.admin.idExist(form_state.id);
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "사용 가능한 아이디 입니다.";
                        state.isShowModal = true;

                        state.idExistCheck = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "사용 불가능한 아이디 입니다.";
                        state.isShowModal = true;
                    }
                }
            };

            const add = async () => {
                if (!state.idIsPossible) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "아이디가 올바르지 않습니다.";
                    state.isShowModal = true;
                } else if (!state.idExistCheck) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "아이디 중복확인을 해주세요.";
                    state.isShowModal = true;
                } else if (!(form_state.name && form_state.name.length > 0)) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "이름이 올바르지 않습니다.";
                    state.isShowModal = true;
                } else if (!state.pwIsPossible) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 올바르지 않습니다.";
                    state.isShowModal = true;
                } else if (!state.pwReCheck) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 올바르지 않습니다.";
                    state.isShowModal = true;
                } else if (form_state.roleList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "담당사업을 선택해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqAdmin = {
                        id: form_state.id,
                        name: form_state.name,
                        pw: form_state.pw,
                        idxRoleList: form_state.roleList.join(","),
                    };

                    const res = await apiService.admin.add(param);
                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "알림";
                        state.modalContent = "등록이 완료되었습니다.";
                        state.isShowModal = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "문제 발생";
                        state.isShowModal = true;
                    }
                }
            };

            const modify = async () => {
                if (form_state.pw && !state.pwIsPossible) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 올바르지 않습니다.";
                    state.isShowModal = true;
                } else if (form_state.roleList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "담당사업을 선택해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqAdminForModify = {
                        idx: props.userInfo.idx,
                        id: form_state.id,
                        name: form_state.name,
                        pw: form_state.pw,
                        idxRoleList: form_state.roleList.join(","),
                        isBlock: false,
                    };

                    const res = await apiService.admin.modify(param);
                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "알림";
                        state.modalContent = "수정이 완료되었습니다.";
                        state.isShowModal = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "문제 발생";
                        state.isShowModal = true;
                    }
                }
            };

            return { state, form_state, closeModal, callBackModal, add, modify, idExist, props };
        },
    };
</script>

<style>
    .blocked,
    input:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
</style>
